export enum Role {
    PermUser = 0,
    TmpUser = 1
}